/* eslint-disable react/no-children-prop */
import Link from '../Link';
import { useState } from 'react';
import IconV2 from './IconV2';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FiCheck } from '@/components/react-icons/main';

const Left = ({ children, style, className, dataTitle }) => {
  return (
    <div className={`left ${className}`} style={style} data-title={dataTitle}>
      {children}
    </div>
  );
};

const Right = ({ children, style, className, dataTitle }) => {
  return (
    <div className={`right ${className}`} style={style} data-title={dataTitle}>
      {children}
    </div>
  );
};

const SortableRow = ({ children, style, className, variant = 'default', route, onClick, active = false, sortable, ...rest }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: sortable.id,
    data: sortable.data
  });

  const sortableStyle = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  const isClickable = typeof onClick === 'function' || !!route;

  const handleClick = (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    if (onClick) {
      onClick(e);
    }
  };

  const content = (
    <div ref={setNodeRef} className={`comp-row-v2 ${variant} ${className} ${isClickable ? 'clickable' : ''} ${active ? 'active' : ''} ${isDragging ? 'dragging' : ''}`} style={{ ...style, ...sortableStyle }} onClick={handleClick} {...attributes} {...listeners} {...rest}>
      {children}
    </div>
  );

  return !isDragging && route ? <Link to={route}>{content}</Link> : content;
};

const RowV2 = ({ children, style, className, variant = 'default', query, route, onClick, active = false, replace = false, sortable, selectable, ...rest }) => {
  const isClickable = typeof onClick === 'function' || !!route;
  const [selected, setSelected] = useState(false);

  const handleClick = (e) => {
    if (selectable) {
      e.preventDefault();
      e.stopPropagation();
      setSelected((prev) => !prev);
    }
  };

  if (sortable) {
    return <SortableRow children={children} style={style} className={className} variant={variant} route={route} onClick={onClick} active={active} sortable={sortable} {...rest} />;
  }

  return (
    <Link to={route} replace={replace}>
      <div className={`comp-row-v2 ${variant || ''} ${className || ''} ${isClickable ? 'clickable' : ''} ${active ? 'active' : ''} ${selectable ? 'selectable' : ''} ${selected ? 'selected' : ''}`} style={style} onClick={onClick} {...rest}>
        {selectable && (
          <div className={'row-v2-checkbox-wrapper'} onClick={handleClick}>
            <div className="row-v2-checkbox" data-title={'Click to select'}>
              <IconV2 icon={FiCheck} />
            </div>
          </div>
        )}
        {children}
      </div>
    </Link>
  );
};

RowV2.Left = Left;
RowV2.Right = Right;

export default RowV2;
